export interface Section {
	/** will be rendered in <h3> */
	title?: string;
	/** will be rendered in <p> */
	text?: string;
	/** will be rendered in <ul> */
	points?: string[];
}

export interface Job {
	name: string;
	type: string;
	title: string;
	description: string;
	iconName: 'business-analyst' | 'designer' | 'marketing' | 'sales' | 'technical-writer';
	route: string;
	sections: Section[];
}

export const jobs: Job[] = [
	{
		name: 'Senior UI Designer',
		type: 'Full-time',
		title: 'Senior UI Designer | SitePen',
		description:
			"We're in need of a senior interaction designer who can create carefree experiences for the user. If you wake up in the morning to innovate and perfect user interaction, we can't wait to talk to you!",
		iconName: 'designer',
		route: 'senior-ui-designer',
		sections: [
			{
				text:
					"As a senior UI Designer at SitePen, you'll create user-centered designs for a variety of complex web and native enterprise applications from concept to launch. Alongside our small team of senior UX designers, you'll work with our customers to deliver meaningful experiences to their end-users. You'll conduct user research, collaborate on business goals and technical limitations, and provide clear visual solutions to the rest of the team."
			},
			{
				text:
					'This position requires a well-organized, seasoned professional who is patient, flexible and has the ability to adapt to changing business requirements and priorities.'
			},
			{
				title: 'Your Responsibilities',
				points: [
					'Elicit requirements from key stakeholders to flesh out entire applications',
					'Conduct thorough discovery activities to map big-picture scope as a starting point for agile design methodology',
					'Collaborate with designers and engineers to create user flows, journeys, and stories for new applications',
					`Work with customers to improve and modernize interaction designs (and no, "burn it all down and start over" doesn't count)`,
					'Create clean, organized, wireframes and mockups with varying degrees of interactivity as needed',
					'Understand the principles of clean, modern design and have the ability to provide feedback to others as well as utilize those principles in your own work'
				]
			},
			{
				title: 'Your Qualifications',
				points: [
					'4+ years in interaction design which we define as the interaction, via an interface, between a system and its user while incorporating information design (defined as how the information is presented within such a system to enable the user to best understand that information)',
					"Additional 3+ years in User Interface Design. This doesn't mean 3 years of reskinning WordPress templates and making cute images for social media.",
					'2+ years of solid, user-focused application design',
					'Experience with Sketch, Figma, Axure, the Adobe Suite, InVision, and other industry-standard design tools'
				]
			},
			{
				title: 'Your Skills and Attributes',
				points: [
					'Strong presentation, communication, and collaboration skills',
					'Must have a positive, outgoing attitude — save the drama for your momma',
					'Highly motivated and a creative problem solver',
					'Must be detail-oriented',
					'Ability to translate projects from concept to completion with minimal oversight',
					'Relentless high standards and high attention to detail',
					'Ability to juggle multiple projects at a time while meeting deadlines and project expectations'
				]
			}
		]
	}
];
